var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg102(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "242px",
    height: "433px",
    viewBox: "0 0 242 433",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-251.68271 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4952 0.318195C21.4009 0.818896 22.8862 1.16462 23.1157 1.87394C23.647 3.58467 24.4319 6.07029 23.6349 7.19687C19.1427 13.3841 12.6761 16.9188 5.2133 18.3017C3.67363 18.5818 0.769407 16.9665 0.207882 15.5657C-0.395907 14.0457 0.382981 10.8925 1.67509 9.95072C6.67447 6.34448 12.0844 3.27471 17.44 0.163217C18.1767 -0.254034 19.4627 0.252628 20.4952 0.318195",
    transform: "translate(469.4764 180.29907)",
    id: "Fill-138",
    fill: "#9FA2A1",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0929 0C10.9623 1.06759 12.6824 2.22004 12.5655 3.17595C12.0186 7.79025 9.76099 11.7211 6.12446 14.8747C4.75959 16.0629 0.922077 14.6067 0.403241 12.6815C-1.36828 6.04369 2.84785 0.518159 10.0929 0",
    transform: "translate(378.64938 409.4973)",
    id: "Fill-141",
    fill: "#9FA2A1",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.08372 0C11.249 2.88227 11.4914 6.60161 11.1758 10.502C10.9196 13.6602 7.48909 15.5516 4.39244 14.2439C-0.158772 12.3164 -1.60418 6.06769 2.12369 3.12208C3.82525 1.77823 6.33184 1.4434 8.47709 0.64704L8.08372 0",
    transform: "translate(378.93045 0)",
    id: "Fill-154",
    fill: "#9FA2A1",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.145 247.705C289.824 247.705 364.145 173.385 364.145 81.7053C364.145 22.7713 238.756 -13.9163 141.318 5.00845C87.1795 15.5236 79.6783 62.1301 35.346 80.989C-2.39396 97.0435 -15.6526 158.795 24.3594 201.14C67.4023 246.691 150.632 247.705 198.145 247.705Z",
    transform: "matrix(0.8660254 -0.5 0.5 0.8660254 0 217.55457)",
    id: "Oval",
    fill: "#F5D4C5",
    fillRule: "evenodd",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg102);
export default __webpack_public_path__ + "static/media/102.57a7ddf2300d44aebbd5d36fdca51132.svg";
export { ForwardRef as ReactComponent };